import * as React from 'react';
import Box from '@mui/material/Box';
import ModalComponent from '@mui/material/Modal';

interface ModalProps {
  children: React.ReactNode | ((handleClose: () => void) => React.ReactNode);
  button: any;
}

const Modal = ({ children, button }: ModalProps) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div>
      {button(handleOpen)}
      <ModalComponent
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>{typeof children === 'function' ? children(handleClose) : children}</Box>
      </ModalComponent>
    </div>
  );
};

export default Modal;

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 743,
  bgcolor: 'background.paper',
  border: '1px solid #F3F3F3',
  boxShadow: 24,
  p: 4,
  borderRadius: '4px'
};
